import React, { Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
const common = require('./common');
const recaptchaRef = React.createRef();

class CheckComplaintStatus extends Component {
  constructor(props) {
    super(props);
    this.jobListRef = React.createRef();
    this.state = { 
      error: false,
      was_validated: false,
      captcha_validated: false,
      complaintId: "",
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if(this.state.error) {
      return common.redirectToError();
    } else {
        return (
          <div class="container2 m-0">
            <main>
              <div class="py-5 text-center">
                <img class="d-block mx-auto mb-4" src="./scrlogo.png" alt="" width="72" height="72" />
                <h2>Check Complaint Status</h2>
                <p class="lead">Your problem is our priority. Track its progress.</p>
              </div>

              <div class="row g-5 justify-content-center">
                <div class="col-md-9 col-lg-9">
                  <form novalidate onSubmit={this.checkComplaint} class={`${this.state.was_validated ? "was-validated" : "needs-validation"}`} >
                    <div class="row g-3">
                      <div class="col-12">
                        <label for="ComplaintID" class="form-label">Complaint ID</label>
                        <input type="text" class="form-control" id="ComplaintID" placeholder="Your Complaint ID e.g. 0c2bd50e-c11e-4ec7-a0b8-8611c41ddb5a" value={this.state.complaintId} onChange={this.ComplaintIdValueChange} required />
                        <div class="invalid-feedback">
                          Please enter your Complaint ID.
                        </div>
                      </div>

                      <div align="center" class="col-12">
                        <ReCAPTCHA ref={recaptchaRef} sitekey="6LcOFvkhAAAAAB6-6hX2_EEA_sUHbZOoCQyGezgt" onChange={this.captchaOnChange} onErrored={this.captchaOnErrored} onExpired={this.captchaOnExpired}/>
                      </div>

                      <div class="col-12">
                        <button type="submit" class={`${this.state.captcha_validated ? "w-100 btn btn-primary btn-lg mt-2" : "w-100 btn btn-primary btn-lg mt-2 disabled"}`} onClick={this.wasValidatedEvent}>Check</button>
                      </div>
                    </div>
                  </form>
                  
                </div>
                
              </div>
              
            </main>
            
            <ToastContainer />
            <footer class="my-5 pt-5 text-muted text-center text-small">
              <p class="mb-1">&copy; {new Date().getFullYear()} SCR ELEKTRONIKS PRIVATE LIMITED</p>
            </footer>
          </div>
        )
    }
  }

  captchaOnChange = async (value) => { 
    this.setState({captcha_validated: true});
  }

  captchaOnErrored = async (value) => { 
    this.setState({captcha_validated: false});
  }

  captchaOnExpired = async (value) => { 
    this.setState({captcha_validated: false});
  }

  wasValidatedEvent = async (e) => { 
    this.setState({was_validated: true});
  }

  checkComplaint = async (e) => {
    e.preventDefault();
    const pathWithQuery = `/complaint-status?complaint-id=${this.state.complaintId}`;
    this.props.history.push(pathWithQuery);
  }

  ComplaintIdValueChange = (e) => {
    this.setState({complaintId: e.target.value});
  }

}

export default CheckComplaintStatus;
